import script from "./modal-setting-processes.vue?vue&type=script&setup=true&lang=js"
export * from "./modal-setting-processes.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__